// extracted by mini-css-extract-plugin
export default {"hamburger":"hamburger_hamburger__nVrSY","open":"hamburger_open__Rgstq"};